import { motion } from "framer-motion";
import { ArrowRight, AudioLines } from "lucide-react";

const GHL_CALENDAR = "https://api.leadconnectorhq.com/widget/booking/1O9DVPsKwdzHA4TLdUny";

const FOOTER_LINKS = {
  Product: ["Features", "Channels", "Industries", "Compare"],
  Company: ["About", "Careers", "Contact", "Blog"],
  Legal: ["Privacy", "Terms", "Security"],
};

export const Footer = () => {
  return (
    <>
      {/* Final CTA */}
      <section id="contact" data-testid="cta-section" className="relative py-28 md:py-36 border-t border-white/5 overflow-hidden">
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/15 blur-[150px]" />
        <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-heading text-4xl md:text-6xl font-black tracking-tighter text-white leading-[1.05]"
          >
            Ready to stop missing customers?
          </motion.h2>
          <p className="mt-5 text-base md:text-lg text-white/60 max-w-xl mx-auto">
            Put your phone and messages on autopilot. Book a free call and
            hear your AI answer a real call for yourself.
          </p>

          <div className="mt-9 flex justify-center">
            <a
              href={GHL_CALENDAR}
              data-testid="contact-book-call"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-8 py-4 text-base font-semibold text-white whitespace-nowrap shadow-[0_0_32px_rgba(255,92,0,0.4)] transition-all duration-300 hover:bg-brand-hover hover:brightness-110 active:scale-95"
            >
              Book a Free Call
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
          <p className="mt-4 text-xs text-white/40">No credit card required · Done-for-you setup · Cancel anytime</p>
        </div>
      </section>

      {/* Footer */}
      <footer data-testid="site-footer" className="border-t border-white/10 bg-[#070707]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
            <div className="col-span-2">
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand">
                  <AudioLines className="h-5 w-5 text-white" strokeWidth={2.5} />
                </span>
                <span className="font-heading text-xl font-extrabold tracking-tight text-white">
                  5B<span className="text-brand"> AI</span>
                </span>
              </a>
              <p className="mt-4 text-sm text-white/50 max-w-xs leading-relaxed">
                The AI employee that answers every call, replies to every message,
                and books appointments 24/7 — so you never miss a customer.
              </p>
            </div>

            {Object.entries(FOOTER_LINKS).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-white">{title}</h4>
                <ul className="mt-4 space-y-3">
                  {links.map((l) => (
                    <li key={l}>
                      <a href="#contact" className="text-sm text-white/50 hover:text-brand transition-colors">{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">© {new Date().getFullYear()} 5B AI. All rights reserved.</p>
            <p className="text-xs text-white/40">Built for business owners, not engineers.</p>
          </div>
        </div>
      </footer>
    </>
  );
};
